/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 08.11.2016.
 */

import React, {Component, PropTypes} from 'react';
import {VelocityTransitionGroup} from 'velocity-react';

import Translate from '../../Translate';

import _get from 'lodash/get';

class AppsMessage extends Component {
  constructor(props) {
    super(props);

    this.animationEnter = {
      translateY: '0px',
      opacity: 1
    };
    this.animationLeave = {
      translateY: '100px',
      opacity: 0
    };

    this.state = {
      isShown: false,
      toClose: false
    };
  }

  componentDidMount() {
    this.setState({
      isShown: this.props.isShown
    });
  }

  componentWillReceiveProps(newProps) {

    this.setState({
      isShown: newProps.isShown
    });
  }

  _onAction(action) {

    if (action) action();

    this._onCrossClick();
  }

  _onAnimationComplete() {

    if (this.state.toClose) this.props.onClose();
  }

  _onCrossClick() {

    this.setState({
      isShown: false,
      toClose: true
    });

    this.props.onClose();
  }

  _renderApps() {

    return _get(Config, 'apps.platforms', []).map((platform) => {

      return <a href={platform.url} key={platform.type} target="_blank">
        <div className="block-1">
          <div className="mv">
            <img src={platform.logo} alt={platform.type} />
          </div>
        </div>
      </a>

    });
  }

  _renderAction() {

    return this.props.message.actions.map((action, index) => {

      return <a key={'action_' + index} className="btn-dark-popup pointer" onClick={this._onAction.bind(this, action.func)}> <Translate content={action.title} /> </a>;
    });
  }

  render() {

    return (
      <div>
        {this.state.isShown && <a className="mw-close ico ico-close pointer slider-resume" href="javascript:void(0)" onClick={this._onCrossClick.bind(this)}></a>}
        {this.state.isShown && <div>
          <div className="popup-block app">
            <div className="crow no-gutter mb+">
              {this._renderApps()}
            </div>
            <VelocityTransitionGroup
              enter={{animation: this.animationEnter, easing: 'ease-in-out', duration: 350}}
              leave={{animation: this.animationLeave, easing: 'ease-in-out', duration: 150, complete: this._onAnimationComplete.bind(this)}}>
              {this.state.isShown ? <div>
                <strong> {_get(Config, 'apps.title', '')} </strong>
                <div className="mt">
                  <em> {_get(Config, 'apps.description', '')} </em>
                </div>
                <div className="mt+ message-actions">
                  {this.props.message.actions && this.props.message.actions.length && this._renderAction()}
                </div>
              </div> : undefined }
            </VelocityTransitionGroup>
          </div>
        </div>}
      </div>
    );
  }
}

AppsMessage.propTypes = {
  message: PropTypes.shape({
    type: PropTypes.string.isRequired,
    title: PropTypes.string,
    body: PropTypes.string,
    actions: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      func: PropTypes.func.isRequired
    }))
  }),
  onClose: PropTypes.func.isRequired,
  isShown: PropTypes.bool.isRequired
};

export default AppsMessage;



// WEBPACK FOOTER //
// ./src/components/ModalWindow/Apps/apps-message.js